import { useListPager } from '@airship-platform/airship-patterns';
import { FlexBox } from '@airship-platform/jam-web/components';
import Box from '@mui/material/Box';
import React, { useState } from 'react';
import { OrganizationSOW } from '../../../data-access';
import SOWCard from './SOWCard';

interface SOWListProps {
  sows: Array<
    OrganizationSOW & {
      actions: React.ReactNode;
    }
  >;
}

const SOWList: React.FC<SOWListProps> = ({ sows }) => {
  const [pageCounter, setPageCounter] = useState(20);

  const { loaderRef } = useListPager({
    incrementBy: 20,
    initialValue: pageCounter,
    maxValue: sows.length,
    callbackFn: setPageCounter,
  });

  const pagedRebates = sows.slice(0, pageCounter);

  return (
    <FlexBox flexDirection={'column'} gap={2}>
      {pagedRebates.map((sow) => (
        <FlexBox flexDirection={'column'} gap={2} key={sow.sowId}>
          <SOWCard sow={sow}>{sow.actions}</SOWCard>
        </FlexBox>
      ))}

      <Box ref={loaderRef} sx={{ height: 50 }} />
    </FlexBox>
  );
};

export default SOWList;
